export const getUserRoles = () => {
    const token = localStorage.getItem('token');
    const defaultRoles = { is_active: false, is_staff: false, is_superuser: false, organization_id: null };
    
    if (!token) return defaultRoles;
    
    try {
        // Разбираем JWT токен (он состоит из 3 частей, разделенных точкой. Нам нужна вторая - payload)
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
        
        const payload = JSON.parse(jsonPayload);
        
        // Принудительно приводим к boolean, чтобы избежать undefined
        return {
            is_active: !!payload.is_active,
            is_staff: !!payload.is_staff,
            is_superuser: !!payload.is_superuser,
            organization_id: payload.organization_id || null
        };
    } catch (e) {
        console.error("Ошибка при чтении токена:", e);
        return defaultRoles;
    }
};